import axios from "axios";

const API_URL = "/api/push-subscriptions";

const getHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token && { auth: token }),
  };
};

const handleRequest = async (url, options = {}) => {
  try {
    const response = await axios({
      url,
      method: options.method || "GET",
      headers: getHeaders(),
      data: options.data,
    });

    const data = response.data;

    if (data && typeof data.success !== "undefined") {
      return data;
    }

    return { success: true, data, message: data?.message || "" };
  } catch (error) {
    const status = error.response?.status;
    const data = error.response?.data;
    let message = data?.message;

    if (!message) {
      if (status === 401 || status === 403) {
        message = "You are not authorized to perform this action.";
      } else if (status >= 500) {
        message = "Server error occurred. Please try again later.";
      } else if (status) {
        message = "Request failed. Please try again.";
      } else {
        message = "Network error. Please check your internet connection.";
      }
    }

    return { success: false, data: null, message };
  }
};

export const pushSubscriptionService = {
  getSubscriptions: async (username = "") => {
    const params = username ? `?username=${encodeURIComponent(username)}` : "";
    return handleRequest(`${API_URL}${params}`);
  },

  getSubscription: async (id) => {
    return handleRequest(`${API_URL}/${id}`);
  },

  deleteSubscription: async (id) => {
    return handleRequest(`${API_URL}/${id}`, { method: "DELETE" });
  },

  sendTestPush: async (username, title, body) => {
    return handleRequest("/api/push-test", {
      method: "POST",
      data: { username, title, body },
    });
  },
};
